// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__a0TpO","tabs":"Tabs_tabs__mElEu","tab":"Tabs_tab__kE2yZ","selected":"Tabs_selected__7WLDu"};